import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30f4b2f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-aside-bar-content" }

import { computed } from 'vue';
import { useLayoutStoreHook } from '@/store/modules/layout';
import Sidebar from './sidebar/index.vue';
import Logo from './logo/index.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const layoutStore = useLayoutStoreHook();

const styleC = computed(() => {
  return {
    width: layoutStore.opened ? '210px' : '54px',
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "layout-aside",
    style: _normalizeStyle(_unref(styleC))
  }, [
    _createVNode(Logo),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Sidebar)
    ])
  ], 4))
}
}

})